import { grpSwitchEndPoints} from '../../config';
import {redirectPage} from '@iso/lib/helpers/utility';
import { getCookie } from '@iso/lib/helpers/session';



class grpSwitchApi {

  /********************************Start findById**********************************/
  findById = async (fetchById) => {
  console.log("fetch type id ",fetchById);
  const fetchListUrl=grpSwitchEndPoints.findById+'/'+fetchById
  return await fetch(fetchListUrl, {
    method: 'get',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      authorization:getCookie('id_token') ? getCookie('id_token') : "",
    },
  })
    //.then(response => response.json())
    .then(function (response) {
        // alert(response);
         if(response.status >=400){
           if(response.status===404){
             redirectPage("/404");
           }else{
             redirectPage("/500");
           }
       }
         return response.json();
       })
    .then(res => {
       return res;
    })
    .catch(error => ({ error }));
  };

  /*******************************End findById*************************************/
  editById = async (editById, switchBody) => {
    console.log("editById type id ",editById);
    const editListUrl=grpSwitchEndPoints.editById+'/'+editById
    return await fetch(editListUrl, {
      method: 'post',
      headers: {
        Accept: '*',
        'Content-Type': 'application/json',
        authorization:getCookie('id_token') ? getCookie('id_token') : "",
      },
      body: JSON.stringify(switchBody),
    })
      //.then(response => response.json())
      .then(function (response) {
          // alert(response);  
           if(response.status >=400){
             if(response.status===404){
               redirectPage("/404");
             }else{
               redirectPage("/500");
             }
         }
           return response.json();
         })
      .then(res => {
         return res;
      })
      .catch(error => ({ error }));
    };

    /*******************************End editSwitchCategory*************************************/

  editSettingMsgs = async (switchBody) => {
    const editListUrl=grpSwitchEndPoints.editSetMsg
    return await fetch(editListUrl, {
      method: 'post',
      headers: {
        Accept: '*',
        'Content-Type': 'application/json',
        authorization:getCookie('id_token') ? getCookie('id_token') : "",
      },
      body: JSON.stringify(switchBody),
    })
      //.then(response => response.json())
      .then(function (response) {
        console.log('AYUSSSresponse', response)
  
           if(response.status >=400){
             if(response.status===404){
               redirectPage("/404");
             }else{
               redirectPage("/500");
             }
         }
           return response.json();
         })
      .then(res => {
         return res;
      })
      .catch(error => ({ error }));
    };

}

export default new grpSwitchApi();
